module.exports = __webpack_public_path__ + "static/assets/816ab8874aa0506a6a4f881add98c888.png";